// extracted by mini-css-extract-plugin
export var articleLink = "bro-nb";
export var articleWrap = "bro-ob";
export var avatar = "bro-tb";
export var avatarImg = "bro-ub";
export var content = "bro-pb";
export var des = "bro-qb";
export var img = "bro-wb";
export var imgWrap = "bro-vb";
export var subtitle = "bro-sb";
export var title = "bro-rb";